"use strict";
// Slider
var sliderImgNum = 0;
var btnBack = document.querySelector(".slider__button--back");
var btnForward = document.querySelector(".slider__button--forward");
var sliderList = document.querySelector(".slider__list");
var countSliderImg = sliderList.children.length - 1;
btnBack.addEventListener("click", function() {
    if (sliderImgNum <= 0) {
        sliderImgNum = countSliderImg;
        sliderList.children[0].classList.remove("slider__photo--active");
    } else {
        sliderList.children[sliderImgNum].classList.remove("slider__photo--active");
        sliderImgNum--;
    }
    sliderList.children[sliderImgNum].classList.add("slider__photo--active");
});
btnForward.addEventListener("click", function() {
    if (sliderImgNum >= countSliderImg) {
        sliderImgNum = 0;
        sliderList.children[countSliderImg].classList.remove("slider__photo--active");
    } else {
        sliderList.children[sliderImgNum].classList.remove("slider__photo--active");
        sliderImgNum++;
    }
    sliderList.children[sliderImgNum].classList.add("slider__photo--active");
});
// Form
var formMessage = document.getElementById("form-message");
formMessage.addEventListener("submit", function(event) {
    event.preventDefault();
    event.target.reset();
});

//# sourceMappingURL=index.bec550fd.js.map
